import { createBlueprint as e } from "@made-people/blueprint";
const r = e({
  slots: {
    base: "border-b border-border-light",
    trigger: "flex items-center justify-between w-full py-4 lg:py-6 cursor-pointer group/facet-trigger text-left gap-4 px-3 text-heading-2xs lg:text-heading-sm",
    content: "pb-6 px-3 text-body-sm bg-background-surface text-balance -mt-2 lg:-mt-4",
    icon: "w-6 h-6",
    item: "border-b border-gray-200 last:border-b-0",
    header: "flex justify-between items-center text-heading-xl",
    headerWrapper: "flex items-center gap-2 pb-3",
    headerLeftImage: "w-5 h-5",
    iconOpen: "group-data-[state=open]:-rotate-180 group-data-[state=closed]:rotate-0 transition-transform transform w-auto w-3.5 h-3.5 mr-6 flex",
    iconClose: "hidden"
  },
  variants: {}
});
export {
  r as accordionBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
